import { useMemo } from "react";
import { ReadCosts } from "@/types/costs";
import { CostsFormSchemaType } from "@/schemas/costsForm";

export const useCostsFormDefaultValues = (data: ReadCosts[]) => {
  return useMemo(() => {
    return {
      costs: data.reduce(
        (costs, item) => {
          costs[item.id] = {
            id: item.id,
            amount: String(item.amount || 0),
            name: item.name,
            comment: item.comment || "",
            include: true,
          };
          return costs;
        },
        {} as CostsFormSchemaType["costs"],
      ),
    };
  }, [data]);
};
